import { ANB_SNACKBAR_DEFAULT_OPTIONS } from '@anb/ng-ui';
import { registerLocaleData } from '@angular/common';
import localeNlExtra from '@angular/common/locales/extra/nl';
import localeNl from '@angular/common/locales/nl';
import { LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppConstants } from '@shared/constants/app.constants';
import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { Error403Component } from './pages/error/error403/error403.component';
import { LoggedOutComponent } from './pages/loggedout/loggedout.component';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { GlobalReducers } from '@core/ngrx/store/global-state';
import { CustomSerializer } from '@core/ngrx/custom-route-serializer';

registerLocaleData(localeNl, AppConstants.locale, localeNlExtra);

@NgModule({
  declarations: [AppComponent, LoggedOutComponent, Error403Component],
  imports: [
    AppRoutingModule,
    CoreModule,
    SharedModule,
    BrowserModule,
    DashboardModule,
    StoreModule.forRoot(GlobalReducers),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
    StoreRouterConnectingModule.forRoot({
      serializer: CustomSerializer,
    }),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: AppConstants.locale },
    { provide: 'LEGEND_MANAGER_ENDPOINT', useValue: null },
    { provide: ANB_SNACKBAR_DEFAULT_OPTIONS, useValue: AppConstants.defaultSnackBarOptions },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
